export default {
  namespaced: true,
  state: {
    isSelectedAll: false, 
    //Items Added to table
    items: [],
    //Added Groups
    groups: [],
    //Added Invoices
    invoices: [],
    //Items in table, this list to implement logic that have to fill to table and sync data with moduleInvoiceDetail component
    filledItems: [],
    eInvoiceConfig: {},
    autoSelectAfterSearch: false,
    //Module hiện tại được chọn ở màn Invoice from module, dùng chia sẻ sang các màn khác (vd: getDetailEInvoiceReservation)
    moduleId: null,
  },
  getters: {
    getTableItems: state => state.items,
  },
  mutations: {
    UPDATE_TABLE_ITEMS:(state, val) => {
      state.items = val
    },
    UPDATE_FILLED_ITEMS:(state, val) => {
      state.filledItems = val
    },
    UPDATE_ADDED_GROUPS: (state, val) => {
      state.groups = val
    },
    UPDATE_ADDED_INVOICES: (state, val) => {
      state.invoices = val
    },
    UPDATE_EINVOICE_CONFIG:  (state, val) => {
      state.eInvoiceConfig = val
    },
    SELECT_ALL: (state, val) => {
      state.isSelectedAll = val;
    },
    setAutoSelectAfterSearch : (state, value) => {
      state.autoSelectAfterSearch = value;
    },
    setModuleId : (state, value) => {
      state.moduleId = value;
    }
  },
  actions: {},
}

